import { useState } from 'react';
import creationRecordService from '../../services/creationRecordService';
import { getLyricsText } from './LyricsRecordPreview';
import {
  downloadText,
  getAbsoluteUrl,
  getMediaUrl,
  isAudioRecord,
  isLyricsRecord,
  isVideoRecord,
  recordDownloadFilename,
} from './creationRecordUtils';

const INITIAL_SHARE_MODAL = {
  open: false,
  platform: null,
  record: null,
  maxLength: 2000,
};

export default function useCreationRecordActions({ loadRecords, loadStats, t }) {
  const [videoModalUrl, setVideoModalUrl] = useState(null);
  const [audioModalRecord, setAudioModalRecord] = useState(null);
  const [lyricsModalRecord, setLyricsModalRecord] = useState(null);
  const [shareModal, setShareModal] = useState(INITIAL_SHARE_MODAL);

  return {
    modalProps: buildModalProps(),
    handlers: buildHandlers(),
    setVideoModalUrl,
  };

  function buildModalProps() {
    return { videoModalUrl, audioModalRecord, lyricsModalRecord, shareModal };
  }

  function buildHandlers() {
    return {
      closeAudio: () => setAudioModalRecord(null),
      closeLyrics: () => setLyricsModalRecord(null),
      closeShare: () => setShareModal(INITIAL_SHARE_MODAL),
      closeVideo: () => setVideoModalUrl(null),
      deleteRecord,
      downloadRecord,
      openShare: (record) => setShareModal({ ...INITIAL_SHARE_MODAL, open: true, record, shareUrl: record.shareUrl }),
      viewRecord,
    };
  }

  function viewRecord(record) {
    if (isLyricsRecord(record)) return setLyricsModalRecord(record);
    if (isAudioRecord(record)) return setAudioModalRecord(record);
    const mediaUrl = getAbsoluteUrl(getMediaUrl(record));
    if (mediaUrl) window.open(mediaUrl, '_blank');
    return undefined;
  }

  async function downloadRecord(record) {
    try {
      if (isLyricsRecord(record)) return downloadLyrics(record);
      const mediaUrl = getMediaUrl(record);
      if (mediaUrl) creationRecordService.downloadImage(mediaUrl, downloadFilename(record));
    } catch (error) {
      console.error('Download failed:', error);
    }
  }

  function downloadLyrics(record) {
    downloadText(getLyricsText(record), `${recordDownloadFilename(record)}.txt`);
  }

  async function deleteRecord(recordId) {
    if (!window.confirm(t('creationRecord.confirmDelete'))) return;
    try {
      await creationRecordService.deleteCreationRecord(recordId);
      await loadRecords();
      await loadStats();
    } catch (error) {
      console.error('Delete failed:', error);
    }
  }
}

function downloadFilename(record) {
  let ext = 'png';
  if (isVideoRecord(record)) ext = 'mp4';
  if (isAudioRecord(record)) ext = (record.audioFormat || 'mp3').replace(/^\./, '');
  return `${recordDownloadFilename(record)}.${ext}`;
}
